import React from "react";

/**
 * ScaleHeader Component - Displays scale title with optional name and Wikipedia link
 * 
 * @param {number} scaleNumber - The scale number identifier
 * @param {Object} scaleInfo - Scale information object with name and source
 * @param {string} scaleInfo.name - The scale name
 * @param {string} scaleInfo.source - Wikipedia or other source URL
 */
const ScaleHeader = ({ scaleNumber, scaleInfo }) => {
  const renderScaleName = () => {
    if (!scaleInfo) return null;
    
    if (scaleInfo.source) {
      return (
        <>
          {' ("'}
          <a 
            href={scaleInfo.source} 
            target="_blank" 
            rel="noopener noreferrer"
            title="View Wikipedia source"
            className="scale-name-link"
          >
            {scaleInfo.name}
          </a>
          {'")'}
        </>
      );
    }
    
    return ` ("${scaleInfo.name}")`;
  };

  return (
    <div className="scale-header">
      <div className="scale-info">
        <div className="scale-title">
          Scale #{scaleNumber}
          {renderScaleName()}
        </div>
      </div>
    </div>
  );
};

export default ScaleHeader;